import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Balad from "../../assets/images/balad.png"
import Nehan from "../../assets/images/neshan.png"
import Gmap from "../../assets/images/gmap.png"
import Logo from "../../assets/images/logo.png"
import {
    faCog,
    faHashtag,
    faFlagCheckered,
    faCalendarAlt,
    faMapMarkerAlt,
    faAddressBook, faBoxes, faBox, faBook, faDownload, faUpload, faTimes,
} from '@fortawesome/free-solid-svg-icons'
import {toast} from "react-toastify";
import Loading from "../Common/Loading";

class Request extends Component {
    state = {
        request: {
            status: [],
            company: [],
            loading_addresses: [],
            unloading_addresses: [],
            consignments: [],
            documents : [],
        },
        document_file: null,
        document_description: '',
        document_title: '',
        buttonStatus: "",
        buttonText : "ارسال فایل",
        loading: "d-none",
        lat: '',
        lng: '',
        routing: 0
    }
    findRoute = (lat, lng) => {
        /* const currentLat = window.localStorage.getItem("d-lat");
         const currentLng = window.localStorage.getItem("d-lng");
      /* if (!currentLat || !currentLng) {
             toast.warning('موقعیت شما پیدا نشد لطفا لوکیشن خود را روشن کرده و دسترسی آن را به اپلیکیشن بدهید');
             return false;
         }*/
        const url ="geo:"+ lat + "," + lng
       /* const url = "http://maps.google.com/maps?saddr="
             + "&daddr="
            + lat + "," + lng*/
        window.open(url)
    }
    finishRequest = () => {
        API.finishRequest(this.props.match.params.id)
            .then((response) => {
                API.request(this.props.match.params.id)
                    .then((response) => {
                        const request = response.results.request;
                        this.setState({request})
                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onDocChange = (event) => {
        this.setState({
            document_file: event.target.files[0]
        })
    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }
    onUploadClick = () => {
        const formData = new FormData();
        const file = this.state.document_file;
        if (file) {
            formData.append('document_file', file);
            if (!this.state.document_title) {
                toast.error('لطفا عنوان فایل ارسالی را مشخص کنید');
                return false;
            }
        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        formData.append('document_title', '-CFD0-' + this.state.document_title);
        formData.append('document_description', this.state.document_description  + '(ارسالی راننده)' );
        formData.append('id', this.state.request.id);

        API.requestDocument(formData)
            .then((response) => {
                toast.success(response.user_message);
                API.request(this.props.match.params.id)
                    .then((response) => {
                        const request = response.results.request;
                        this.setState({request})
                        this.setState({
                            document_file: [],
                            document_title: '',
                            document_description: ''
                        })
                    })
                const buttonText  = 'ارسال فایل'
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
            })
            .catch((error) => {
               // toast.error(error.response.data.user_message);
            });
    }
    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='اطلاعات درخواست '/>
                {
                    this.state.routing ?
                        <section className="container-fluid fixed-bottom w-100 max-w-lg" id='map-selector'>
                            <div className="row">
                                <div className="col-12 py-3">
                                    <button className="btn text-danger w-25 float-left text-left"
                                            onClick={() => {
                                                this.setState({
                                                    routing : 0
                                                })

                                            }}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </div>

                                    {
                                    this.state.notVerified ?
                                        <div className="col-12 px-2">
                                            <div className=" alert alert-danger super-small text-center">
                                                این آدرس هنوز توسط مدیریت سامانه تایید نشده است و موقعیت مکانی آن توسط مشتری به صورت حدودی وارد شده است. در استفاده از این آدرس برای مسیریابی احتیاط کنید
                                            </div>
                                        </div>
                                        : ''
                                    }

                                <div className="col-12 mt-2">
                                    <button className="btn btn-dark w-100 small"
                                    onClick={() => {
                                        this.setState({
                                            routing : 0
                                        })
                                        window.open(`https://maps.neshan.org/@${this.state.lat},${this.state.lng},14.5z,0.0p/routing/external=true`)
                                    }}
                                    >
                                        <img src={Nehan} alt="neshan" width='32' className='float-right'/>
                                        مسیریابی با نقشه نشان
                                    </button>
                                </div>
                                <div className="col-12 mt-3">

                                    <button className="btn btn-dark w-100 small"
                                            onClick={() => {
                                                this.setState({
                                                    routing : 0
                                                })
                                                window.open("http://maps.google.com/maps?saddr=&daddr=" + this.state.lat + "," + this.state.lng + "&external=true")
                                            }}
                                    >
                                        <img src={Gmap} alt="Google Map" width='32' className='float-right'/>
                                        مسیریابی با نقشه گوگل
                                    </button>
                                </div>
                                <div className="col-12 mt-3">

                                    <button className="btn btn-dark w-100"
                                            onClick={() => {
                                                this.setState({
                                                    routing : 0
                                                })
                                                window.open(`geo:${this.state.lat},${this.state.lng}&external=true`)
                                            }}
                                    >
                                        <img src={Balad} alt="Balad" width='32' className='float-right'/>
                                        مسیریابی با دیگر مسیریاب ها
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 text-center pt-2 mt-5">
                                    <img src={Logo} alt="Barsepar" width='120' />
                                </div>

                            </div>
                        </section>
                        : ''
                }

                <section className="container mt-4 rtl pt-5">
                    <div className="row px-2 border-bottom pb-2">
                        <div className="col-1 ">
                            <FontAwesomeIcon icon={faHashtag} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            کد پیگیری
                        </div>
                        <div className="col-7 text-left fw-bold text-primary">
                            {this.state.request.tracking_code}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCog} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            وضعیت درخواست
                        </div>
                        <div className="col-7 text-left fw-bold super-small"
                             style={{color: this.state.request.status.color}}>
                            {this.state.request.status.title}
                        </div>
                        {
                            ( this.state.request.status.id === 6 ) ?
                                <div className="col-12 mt-3">
                                    <button className='btn btn-success w-100' onClick={this.finishRequest}>
                                        بار تخلیه شد
                                        <FontAwesomeIcon icon={faDownload} className='text-white small float-left'/>
                                    </button>
                                </div> : ''
                        }

                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faFlagCheckered} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            نام شرکت
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.company.title}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            تاریخ بارگیری
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.loading_date}
                            &nbsp;
                            -
                            &nbsp;
                            {this.state.request.loading_time}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faCalendarAlt} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            تاریخ تخلیه
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.unloading_date}
                            &nbsp;
                            -
                            &nbsp;
                            {this.state.request.unloading_time}
                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faBook} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            بارنامه
                        </div>
                        <div className="col-7 text-left fw-bold super-small">
                            {this.state.request.waybill ?
                                <a href={this.state.request.waybill + "?external=true"} target='_blank' rel="noreferrer"> دانلود بارنامه</a> :
                                <span> الحاق نشده است</span>
                            }

                        </div>
                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faAddressBook} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            آدرس های بارگیری
                        </div>

                        {
                            this.state.request.loading_addresses.map(address => {
                                return (
                                    <div className="row mt-3">
                                        <div className="col-1">
                                            &nbsp;
                                        </div>
                                        <div className="col-1">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className='text-secondary small'/>
                                        </div>
                                        <div className="col-8 small line-height-2">
                                            <b>{address.title}</b>
                                            &nbsp;
                                            {address.address}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            {address.contact_name}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            <a href={'tel:' + address.contact_number}> {address.contact_number}</a>
                                            <div className='col-12 text-start super-small mt-2'>
                                                <span className='btn btn-outline-info super-small'
                                                onClick={() => {
                                                    window.localStorage.setItem("latE", address.lat);
                                                    window.localStorage.setItem("lngE", address.lng);
                                                    window.localStorage.setItem("addressE", address.address);
                                                    window.location.assign('/location/' + address.id)
                                                }}
                                                >
                                                اصلاح آدرس
                                            </span>
                                            </div>

                                        </div>
                                        <div className="col-2 ">
                                            <button className='btn btn-outline-secondary super-small-2 '
                                                    onClick={() => {
                                                        this.setState({
                                                            routing: 1,
                                                            lat: address.lat,
                                                            lng: address.lng,
                                                            notVerified: !address.is_verify
                                                        })
                                                    }}


                                            >
                                                مسیریابی
                                                {

                                                    !address.is_verify ?
                                                        <span className='badge badge-info badge-pill bg-warning '>
                                                        تایید نشده
                                                    </span>
                                                        : ''
                                                }
                                            </button>

                                        </div>


                                    </div>
                                )
                            })
                        }

                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faAddressBook} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            آدرس های تخلیه
                        </div>

                        {
                            this.state.request.unloading_addresses.map(address => {
                                return (
                                    <div className="row mt-3">
                                        <div className="col-1">
                                            &nbsp;
                                        </div>
                                        <div className="col-1">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className='text-secondary small'/>
                                        </div>
                                        <div className="col-8 small line-height-2">
                                            <b>{address.title}</b>
                                            &nbsp;
                                            {address.address}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            {address.contact_name}
                                            &nbsp;
                                            -
                                            &nbsp;
                                            <a href={'tel:' + address.contact_number}> {address.contact_number}</a>
                                            <div className='col-12 text-start super-small mt-2'>
                                                <span className='btn btn-outline-info super-small'
                                                      onClick={() => {
                                                          window.localStorage.setItem("latE", address.lat);
                                                          window.localStorage.setItem("lngE", address.lng);
                                                          window.localStorage.setItem("addressE", address.address);
                                                          window.location.assign('/location/' + address.id)
                                                      }}
                                                >
                                                اصلاح آدرس
                                            </span>
                                            </div>
                                        </div>
                                        <div className="col-2 ">
                                            <button className='btn btn-outline-secondary super-small-2 '
                                                    onClick={() => {
                                                        this.setState({
                                                            routing : 1,
                                                            lat:address.lat,
                                                            lng:address.lng,
                                                            notVerified: !address.is_verify
                                                        })
                                                    }}


                                            >
                                                مسیریابی
                                                {

                                                    !address.is_verify ?
                                                        <span className='badge badge-info badge-pill bg-warning '>
                                                        تایید نشده
                                                    </span>
                                                        : ''
                                                }
                                            </button>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                    <div className="row px-2  mt-4 border-bottom pb-2">
                        <div className="col-1">
                            <FontAwesomeIcon icon={faBoxes} className='text-secondary small'/>
                        </div>
                        <div className="col-4 text-right super-small text-secondary">
                            محموله ها
                        </div>

                        {
                            this.state.request.consignments.map(cons => {
                                return (
                                    <div className="row mt-3">
                                        <div className="col-1">
                                            &nbsp;
                                        </div>
                                        <div className="col-1">
                                            <FontAwesomeIcon icon={faBox} className='text-secondary super-small'/>
                                        </div>
                                        <div className="col-8 small line-height-2">
                                            {cons.title}


                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                    <div className="row mt-4 bg-light py-3">
                        <div className="col-12 text-right super-small text-secondary">
                            فایل های الحاقی
                        </div>
                        <div
                            className='row text-center py-3 m-auto mt-2 transactions-header  '>
                            <div className="col-3">عنوان</div>
                            <div className="col-6">توضیحات</div>
                            <div className="col-3">دانلود</div>

                        </div>
                        {
                            this.state.request.documents.map(doc => {

                                return (
                                    <div
                                        className='row text-center text-dark py-3 m-auto mt-2 transactions-body  '
                                        key={doc.id}>
                                        <div className="col-3 fw-bold">
                                            {doc.title? doc.title.replace('-CFD0-' , '') : ''}
                                        </div>
                                        <div
                                            className="col-6 super-small"> {doc.description}
                                            {
                                                doc.title?
                                                    doc.title.indexOf('-CFD0-') === -1 &&
                                                    <span className='text-info px-2'>
                                                                                        (
                                                                                        ارسالی از سامانه
                                                                                        )
                                                                                    </span>
                                                    :  <span className='text-info px-2'>
                                                                                        (
                                                                                        ارسالی از سامانه
                                                                                        )
                                                                                    </span>
                                            }
                                        </div>
                                        <div className="col-3 small">
                                            <a href={doc.path+ "?external=true"} target="_blank"
                                               rel="noreferrer">
                                                <FontAwesomeIcon
                                                    icon={faDownload}/>&nbsp;
                                                دانلود
                                            </a>
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>
                    <div
                        className="row mx-2 mx-md-5 p-md-5 mb-2 pb-4 border rounded text-center pt-5 bg-white">
                        <div className="col-md-4 ">
                            <label className="custom-file-upload">
                                انتخاب فایل
                                <input type="file" onChange={this.onDocChange} accept="image/*" />
                            </label>
                        </div>
                        <div className="col-md-8 small mb-3 mt-2 text-secondary">
                            لطفا مستندات خود را در قالب فایل هایی با پسوند
                            .doc,
                            .pdf,
                            .jpg,
                            .png
                            ارسال فرمایید.
                            <div className=" text-success super-small bg-light mt-2 p-2">
                                &nbsp;
                                {
                                    this.state.document_file ?
                                        " فایل انتخاب شده : " +
                                        this.state.document_file.name
                                        : ''
                                }
                            </div>
                        </div>
                        <div className="form-floating col-md-4 mt-2">
                            <input type="text"
                                   className="form-control px-5"
                                   id="document_title" name="document_title"
                                   placeholder="عنوان فایل"
                                   value={this.state.document_title}
                                   onChange={this.onInputChange}/>
                            <label htmlFor="document_title" className="super-small">عنوان
                                فایل</label>
                        </div>
                        <div className="form-floating col-md-8">

                                        <textarea className="form-control"
                                                  placeholder="توضیحات"
                                                  id="document_description"
                                                  name="document_description"
                                                  value={this.state.document_description ? this.state.document_description : ''}
                                                  onChange={this.onInputChange}
                                        />

                            <label htmlFor="document_description"
                                   className="super-small">توضیحات</label>
                        </div>

                        <div className="col-md-6 text-left mt-3">
                            <button className="btn btn-success p-2 w-100"
                                    onClick={this.onUploadClick} disabled={this.state.buttonStatus}>
                                <FontAwesomeIcon icon={faUpload}/>

                                &nbsp;
                                {this.state.buttonText}
                                <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                       aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>

                </section>


            </React.Fragment>
        );
    }

    componentDidMount() {
        API.request(this.props.match.params.id)
            .then((response) => {
                const request = response.results.request;
                this.setState({request})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)
            })

    }
}

export default Request;